module.exports = __webpack_public_path__ + "img/Image1.f24a9247.png";